export default __webpack_public_path__ + "static/media/os-checkout.5faa93d3.png";